/** Parse a form select string id into a finite number, or null when blank/invalid. */
export const parseOptionalId = (value: string | null | undefined): number | null => {
  if (value == null || value === '') return null
  const parsed = Number(value)
  return Number.isFinite(parsed) ? parsed : null
}
